<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <!-- 产品定制_我的设计 -->

    <div class="form-body">
       <el-form label-width="80px" ref="form" :model="queryParams">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              prop="groupType"
              label="合成类型："
              class="hide_input"
            >
              <el-select
                clearable
                v-model="queryParams.groupType"
                placeholder="请选择合成类型"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="(value, index) in groupTypeArray"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品名称：" prop="proName">
              <el-input
                size="small"
                v-model="queryParams.proName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品编号：" prop="pId">
              <el-input
                size="small"
                v-model="queryParams.pId"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
         
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="产品名称：" prop="designProName">
              <el-input
                size="small"
                v-model="queryParams.designProName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="remitFlag"
              label="是否汇出："
              class="hide_input"
            >
              <el-select
                clearable
                v-model="queryParams.remitFlag"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option label="是" value="1"> </el-option>
                <el-option label="否" value="0"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="text-align:right;">
              <el-button size="small" type="primary" @click="getList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <el-row>
        <el-col :span="8">
          <el-button @click="handleBack" size="small" type="primary"
            >返回我的优选</el-button
          >
        </el-col>
        <el-col
          :span="16"
          style="text-align: right;height:36px;line-height:36px;"
        >
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
      <div>
        <el-row style="display: flex;flex-wrap: wrap;background-color: white">
          <el-col
            :span="12"
            style="display: flex;padding-left: 20px;color: #333333;font-size:14px;align-items: center"
          >
            <div v-if="rowSelectNum > 0">已选中{{ rowSelectNum }}条数据</div>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>

        <el-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          class="clain-tab"
          border
          @selection-change="tableSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column label="产品编号" align="center" prop="designId">
            <template slot-scope="scope">
              <span
                @click="handleJumpDesign(scope.row)"
                class="el-button--text"
                style="cursor: pointer;"
                >{{ scope.row.designId }}</span
              >
            </template>
          </el-table-column>
            <el-table-column label="合成类型" align="center" prop="designId">
            <template slot-scope="scope">
              <span>{{
                scope.row.groupType == "01" ? "多素材组合" : "单素材组合"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column width="230px" align="center" label="产品信息">
            <template slot-scope="scope">
              <el-row type="flex">
                <el-col style="width: 300px">
                  <el-popover
                    placement="right"
                    width="300"
                    trigger="hover"
                    :close-delay="closeDelay"
                  >
                    <img
                      class="img-big"
                      :src="`${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_300,w_300`"
                      style="width: 300px;height: 300px"
                    />
                    <img
                      slot="reference"
                      class="img-small"
                      :src="`${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`"
                    />
                  </el-popover>
                </el-col>
                <div style="min-width: 108px; margin: 0 0 0 0;">
                  <div
                    :title="scope.row.designProName"
                    style="overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;text-align: left;
                    padding: 0 0 0 8px;"
                  >
                    {{ scope.row.designProName }}
                  </div>
                </div>
              </el-row>
            </template>
          </el-table-column>

          <el-table-column label="价格" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="汇出店铺" align="center" prop="shopList">
            <template slot-scope="scope">
              <div
                :title="record"
                class="text-ellipsis"
                v-for="(record, index) in scope.row.shopList"
                :key="index"
              >
                {{ record }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="添加时间"
            align="center"
            prop="createTime"
          ></el-table-column>
          <el-table-column
            label="操作"
            prop="hand"
            width="100"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleRecover(scope.row)"
                >恢复</el-button
              ><br />
              <el-button
                type="text"
                size="small"
                @click="handleDelItem(scope.row)"
                >彻底删除</el-button
              ><br />
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {listYx ,delDesign, updateDesign, getCartInfo} from '@/api/customProduct/design'
import {mapGetters} from 'vuex'
import {addCart, addOrEdit} from '@/api/order/cart'
import {getDesignSku} from '@/api/customProduct/designSku'
import {getAllShop} from "@/api/plat/platType";
import {moveToRelease} from "@/api/customProduct/custom";
import {addToShoppingCart} from'@/api/customProduct/custom'
import CKEditor4 from '@/components/common/CKEditor'

export default {
    name: "product",
    components:{Breadcrumb, CKEditor4},
    data(){
        return{
            // 遮罩层
            loading: true,
            closeDelay:0,
            total:0,
            queryParams:{
                pageNum: 1,
                pageSize: 30,
                timeRange: null,
                designId: null,
                designProName: null,
                proName: null,
                productType: null,
                operNo: null,
                remitFlag: null,
                beginTime: null,
                endTime: null,
                groupType: '',
                delFlag: '0'
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            attribute: {},
            currentAttr: {
              color: "",
              size: "",
            },
            currentSku: {},
            mainPic: '',
            productNum: 1,
            tableData:[],
            cartDetail: {},
            claimCollIds:[],////选中 的产品id
            cartDialogVisible: false,
            cartData: [],
            commodity: {},
            totalCount: 0,
            totalNum: 0.00,
            totalPrice: 0.00,
             groupTypeArray: [
              {label : '多素材组合' ,value: '01'},
               {label : '单元素组合' ,value: '02'},
                {label : '简单商品' ,value: '03'},

            ],
            /*临时字段区--用于记录*/
            lastId: "",
            platList:[],
            shopSelectDialog:false,
            shopList:[],
            checkAll: false,
            checkedShops: [],
            checkPlat:undefined,
            isIndeterminate: true,
            currentRow:null,
            /* 新增的修改需求用到的字段 */
            colors: [],
            sizes: [],
            form: {},
            singlePrice: '',
            editVisible: false,
            detailInfo: {},
            editor: null,
            editorConfig:{
              allowedContent: true,//设置为true，以防止CKEditor 4删除不允许的元素
              extraPlugins:['uploadImg'],
              height:'300px',
              toolbar : [
                  [ 'Maximize'],
                  [ 'Bold', 'Italic', 'Underline', 'Strike'],
                  [ 'TextColor', 'BGColor' ],
                  [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                  [ 'HorizontalRule','RemoveFormat'],
                  [ 'Undo', 'Redo' ],
                  '/',
                  [ 'Styles', 'Format', 'Font', 'FontSize' ],
                  [ 'Table'],
                  [ 'uploadImg']
              ],
              language: 'zh-cn',
              wordcount:{
                  showCharCount: true,
              }
            },
        }
    },

    computed:{
        rowSelectNum(){
            return this.claimCollIds.length;
        },

        ...mapGetters(['nginx','dictData']),

    },
    watch:{
        shopSelectDialog(val, oldVal){
            if(!val){
                this.checkedShops = [];
            }
        }
    },
    created() {
        this.getList();
        this.initPlatData();
    },
    methods:{
      handleExport(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$router.push('/carry/proCustom/createTemplateData?designId=' + this.claimCollIds.join(','))
      },
      handleBack(){
        this.$router.push({ path: "/custom/custom/mynormal"})
      },
      handleJumpProduct(row){
       this.$router.push({ path: "/select/custom/product", query: { pId: row.pId } })
      },
      handleJumpDesign(row){
       this.$router.push({ path: "/select/custom/product", query: { designId: row.designId } })
      },
      handleJump(path){
        this.$router.push({path: path})
      },
      async handleAddCart() {
        let form = this._.clone(this.currentSku)
        form.pId = this.cartDetail.pId
        form.productType = this.cartDetail.productType
        form.designId = this.cartDetail.designId
        form.productNum = this.productNum
        try {
          await addCart(form)
          this.$store.dispatch("GetIndexStat")
          this.msgSuccess("加入购物车成功")
        } catch (error) {}
      },
      // table数据
      getList(){
            this.loading = true;
            if(this.queryParams.timeRange){
              this.queryParams.beginTime = this.queryParams.timeRange[0]
              this.queryParams.endTime = this.queryParams.timeRange[1]
            }
            listYx(this.queryParams).then((re) => {
                this.tableData = re.rows;
                this.total = re.total;
                this.loading = false;
            }).catch(err =>{this.loading = false});
      },

        resetForm(){
           this.queryParams.productType = null
          this.queryParams.remitFlag = null
          this.queryParams.timeRange = []
          let params =  {
              timeRange: null,
              designId: null,
              designProName: null,
              proName: null,
              productType: null,
              operNo: null,
              remitFlag: null,
              beginTime: null,
              endTime: null,
              delFlag: '1'
          }
            this.$refs['form'].resetFields();
        },
        tableSelectionChange(val){
            this.claimCollIds = [];
            val.forEach(r =>{
                this.claimCollIds.push(r.designId)
            });

        },

        /*跳到我的详情*/
        showDetail(row){
            this.$router.push({path:'/carry/proCustom/particulars', query: row})
        },

        /*点击加入购物车*/
        async handleShowCart(row) {
          try {
            let cartData = await getCartInfo(row.designId)
            this.cartDetail = cartData.data
            this.attribute = JSON.parse(cartData.data.attribute)
            let properVal = cartData.data.skuList[0].properVal.split(":")
            this.currentAttr.color = properVal[0]
            this.currentAttr.size = properVal[1].replace(/\\/g, "")
            this.currentSku = cartData.data.skuList[0]
            this.mainPic = this.currentSku.picList[0].picUrl
            this.cartDialogVisible = true
          } catch (error) {
          }
        },
          /*编辑设计*/
        async handleShowEdit(row) {
          try {
            this.detailInfo = row
            this.editVisible = true
          } catch (error) {
          }
        },
        handleSaveDesign(){
          this.detailInfo.remarks = this.editor.getData()
          updateDesign(this.detailInfo).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              this.editVisible = false;
          }).catch(err =>{

          });
        },


        /*确认加入购物车*/
        confirmAddCart() {
            if (this.totalCount == 0) {
                this.$message({
                    message: '请至少添加一件!',
                    type: 'warning'
                });
            } else {
                this.cartDialogVisible = false;
                let i = 0;
                this.cartData.forEach(item =>{
                    i++;
                    if (item.count != 0) {
                        let params ={
                            designId:item.designId,//商品id
                            operNo:this.$store.state.user.name,//操作人
                            properName:'颜色:尺码',
                            properVal:item.color +":"+ item.size,
                            num:item.count,//商品数量
                            price:item.price,//商品价格
                            skuId:item.skuId,
                            selfType:'01',
                        }
                        addToShoppingCart(params); //创建购物车
                    }
                    if (this.cartData.length==i)
                        this.$message({message: "加入购物车成功", type:"success", duration: 700});
                });
                this.lastId = "";
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
            }
        },

        /*购物车弹框的计数*/
        getTotalCount(val1,obj){
            let count = 0; let price = 0.00;
            this.cartData.forEach(item =>{
                if(item.count != 0){
                    count += item.count;
                    price += item.price * item.count;
                }
            })
            this.totalCount = count;
            if (count == 0) {
                this.totalNum = 0.00;
            } else {
                this.totalNum = (price/count).toFixed(2);
            }
            this.totalPrice = price.toFixed(2);
        },

        /*通过商品id获取skuList*/
        getSkuList(designId) {
            if (this.lastId != designId) {
                this.lastId = designId;
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
                getDesignSku(designId).then((re) => {
                  let cacheColor = [];
                  let cacheSize = [];
                  let colors = [];
                  let sizes = [];
                    this.cartData = re.data;
                    re.data.forEach(e => {
                      if (cacheColor.indexOf(e.color) < 0) {
                        cacheColor.push(e.color);
                        colors.push(e);
                      }
                      if (cacheSize.indexOf(e.size) < 0) {
                        cacheSize.push(e.size);
                        sizes.push(e)
                      }
                      });
                    this.colors = colors;
                    this.sizes = sizes;

                })
            }
            this.cartDialogVisible = true;
        },

        handleCommand(val){
            if(this.claimCollIds.length==0){
                this.$message('请选择批量操作的数据！');
                return
            }
        },

        /*添加/修改备注*/
        addRemark(index) {
            let remark = this.tableData[index].remark;
            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: remark,
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '格式不正确'
            }).then(({ value }) => {
                if (remark != value) {
                    this.tableData[index].remark = value;
                    updateDesign(this.tableData[index]).then(re => {
                        this.$message({
                            type: 'success',
                            message: '修改成功! 新备注是: ' + value
                        });
                    }).catch(err =>{

                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },

        //获取店铺数据
        async initPlatData(){
            let platDict;
            await this.getDicts("s_plat_code").then(res => {
                platDict = res.data;
            });
            let platCode = JSON.parse(JSON.stringify(this.$store.state.product.amazon.shopList));
            //获取所有平台代码
            let data = [];
            platDict.forEach(dict => {
                let map ={};
                map.platNo = dict.dictValue;
                map.platName = dict.dictLabel;
                map.shopList = [];
                platCode.forEach(code =>{
                    if(dict.dictValue == code.platNo){
                        map.shopList.push(code)
                    }
                });
                data.push(map);
            });
            this.platList = data.filter(item => {return item.shopList.length > 0});
        },
        platSelect(val,row){
            let shopList = this.platList.filter(plat =>{
                return plat.platNo == val;
            });
            this.shopSelectDialog = true;
            this.shopList = shopList[0].shopList;
            this.currentRow = row;
            this.checkPlat = val;
        },

        submitSelect(){
            let that =this;
            let params = {
                designId:this.currentRow.designId,
                shopIds:this.checkedShops,
                takePlat:this.checkPlat,
                row:this.currentRow
            }
            moveToRelease(params).then(res =>{
                if (res.code == 200) {
                    that.msgSuccess("已成功移入到待发布");
                    that.shopSelectDialog = false;
                }
            }).catch(err =>{});
        },
        handleJumpToBin() {
          this.$router.push({
            path: '/carry/proCustom/recycleBin'
          })
        },
        // 删除当前设计
        handleDelItem(row) {
          this.$confirm('是否确认删除', "警告", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
          }).then(async () => {
            await delDesign(row.designId)
            this.getList();
            this.msgSuccess("删除成功");
          }).catch(function() {});
        },
        handlePickColor() {

        },
        async handleRecover(row) {
          await updateDesign({
            delFlag: '1',
            designId: row.designId
          })
          this.msgSuccess("恢复成功");
          this.getList();
        },
        handleReDesign(row) {
          window.open('/design/online/designer?pId=' + row.pId)
        },
        getEditor(editor){
            this.editor = editor;
        },
        handleSelectColor(color) {
          this.currentAttr.color = color
          this.selectSku()
        },
        handleSelectSize(size) {
          this.currentAttr.size = size
          this.selectSku()
        },
        selectSku() {
          for (let record of this.cartDetail.skuList) {
            if (
              record.properVal ===
              `${this.currentAttr.color}:${this.currentAttr.size}`
            ) {
              this.currentSku = record
              this.mainPic = this.currentSku.picList[0].picUrl
              break
            }
          }
        },
    }
}
</script>

<style lang="scss" scoped>
.searchBox {
  margin-top: 1.5%;
  border: 1px solid #d7d7d7;
}

.clain-tab .img-small {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  border: 1px solid #ccc;
  padding: 1px;
}

.el-table >>> .cell {
  max-height: 120px;
  line-height: 25px !important;
}

.el-dialog__wrapper >>> .el-dialog {
  width: 20%;
}

.cartType .el-row {
  padding: 3% 0px;
  border-bottom: 1px dashed #88888847;
  text-align: center;
}

.cart-but {
  background: #ff5561;
  width: 95%;
  height: 36px;
  font-size: 18px;
  color: white;
  margin-bottom: 2%;
  margin-left: 2%;
  line-height: 0;
}
.wrapper {
  margin-bottom: 5px;
}
.color-wrapper {
}
.color-wrapper .color-item {
  height: 40px;
  display: inline-block;
  margin-left: 5px;
  padding: 1px;
  border: 1px solid #e3e3e3;
  cursor: pointer;
}
.size-wrapper {
}
.size-wrapper .size-item {
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 5px;
  padding: 1px 15px;
  border: 1px solid #f0f0f0;
  background: #f0f0f0;
  cursor: pointer;
}
.price-wrapper {
  color: #4934b2;
}
.price-wrapper .price {
  font-size: 20px;
  font-weight: 800;
}
.sku-attr {
  overflow: hidden;
  margin-top: 15px;
  padding: 0 0 0 8px;
  height: 40px;
  .sku-name {
    margin: 0 32px 0 0;
    float: left;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  padding: 4px;
  border: 1px solid #aaaaaa;
  cursor: pointer;
}
.sku-size {
  margin: 0 8px 0 0;
  padding: 4px 8px;
  border: 1px solid #aaaaaa;
  cursor: pointer;
}
.is-select {
  border: 2px solid #0099e1;
}
.sku-price {
  font-size: 20px;
}
</style>
